var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "back-contianer",
      class: _vm.noBorder ? "back-contianer-reset" : "",
    },
    [
      _c(
        "i",
        {
          staticClass: "el-icon-arrow-left elm-icon",
          on: { click: _vm.handleGotoBack },
        },
        [_vm._v("返回")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }